import { useEffect } from "react";

/** While mounted: `<meta name="referrer" content="no-referrer">`, so a token page never leaks its address. */
export function useNoReferrer(): void {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "referrer";
    meta.content = "no-referrer";
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);
}
